import React, { useRef, useState } from "react";
import { Button, InputAdornment, Icon } from "@material-ui/core";
import { TextFieldFormsy } from "@fuse";
import Formsy from "formsy-react";
import * as Actions from "app/auth/store/actions/login.actions";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import { useMutation, gql } from "@apollo/client";
import { loginDataFields } from "app/main/users/graphql/UserLoginData";
import jwtService from "app/services/jwtService";

const LOGIN_MUTATION = gql`
  ${loginDataFields}
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...LoginDataFields
    }
  }
`;

function JWTLoginTab(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [exec, { loading }] = useMutation(LOGIN_MUTATION);

  const [isFormValid, setIsFormValid] = useState(false);
  const formRef = useRef(null);

  function disableButton() {
    setIsFormValid(false);
  }

  function enableButton() {
    setIsFormValid(true);
  }

  function handleSubmit(model) {
    const { password } = model;
    // Trim all white space from the email input
    const email = model.email.replace(/\s/g, "");
    exec({ variables: { email, password } })
      .then(({ data }) => {
        const { login } = data;
        if (login?.user && login?.token) {
          jwtService.setSession(login.token);
          dispatch(Actions.loginSuccess(login.user));
        }
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== "production") {
          console.error(error.graphQLErrors[0]);
        }
        formRef.current.updateInputsWithError({
          password: t([
            "error.server_side." + error.graphQLErrors[0]?.extensions?.code,
            "error.server_side.unknown_server_error",
          ]),
        });
      });
  }

  // Reset error when changing any component of the form
  function handelChange() {
    formRef.current.updateInputsWithError({
      email: null,
      password: null,
    });
  }

  // Trim all white space from the email input
  function trimWhiteSpace(value) {
    return value.replace(/\s/g, "");
  }

  return (
    <div className="w-full">
      <Formsy
        onValidSubmit={handleSubmit}
        onValid={enableButton}
        onInvalid={disableButton}
        onChange={handelChange}
        ref={formRef}
        className="flex flex-col justify-center w-full"
      >
        <TextFieldFormsy
          className="mb-16"
          type="email"
          name="email"
          label="Email"
          id="login-email"
          value=""
          valueHandler={trimWhiteSpace}
          validations={{
            isEmail: true,
          }}
          validationErrors={{
            isEmail: t("error.form.email"),
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Icon className="text-20" color="action">
                  email
                </Icon>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
        />

        <TextFieldFormsy
          className="mb-16"
          type="password"
          name="password"
          label="Password"
          id="login-password"
          value=""
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Icon className="text-20" color="action">
                  vpn_key
                </Icon>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          id="login-button"
          className="w-full mx-auto mt-16 normal-case"
          aria-label={t("login")}
          disabled={!isFormValid || loading}
          value="legacy"
        >
          {loading && <CircularProgress className="mr-16" size={15} />}
          {t("login")}
        </Button>
      </Formsy>
    </div>
  );
}

export default JWTLoginTab;
